module.exports = __webpack_public_path__ + "static/media/share.a13ba344.png";